enum LocationType {
  Location = 0,
  Station = 1,
  Branch = 2,
  Mall = 3,
  Shop = 4,
  Sensor = 100,
  MeasureItem = 101,
}

export default LocationType;
